
export const industryOptions = [
  { label: 'Plumbing & Septic', value: 'plumbing' },
  { label: 'Landscaping, Hardscaping, Tree Services, & Snow Removal', value: 'landscaping' },
  { label: 'Windows, Doors, & Siding', value: 'windows' },
  { label: 'Roofing', value: 'roofing' }
];
